<div class="link" [ngClass]="{ 'big' : link.big, 'on' : link.active }">
    <mat-icon svgIcon="arrow" [ngClass]=" { 'active' : link.active }"></mat-icon>
    <span class="font-body2 text">{{link.name}}</span>
</div>
